import { jsx as _jsx } from "react/jsx-runtime";
export function Html({ content, ...props }) {
    return _jsx("div", { ...props, dangerouslySetInnerHTML: {
            __html: content
        } });
}
